import { Mail, MessageSquare, Phone } from "lucide-react";
import { createElement } from "react";

export const channelIcon = (channel: string) => {
  switch (channel.toLowerCase()) {
    case "email":
      return createElement(Mail, { size: 14, className: "inline mr-1" });
    case "sms":
      return createElement(Phone, { size: 14, className: "inline mr-1" });
    default:
      return createElement(MessageSquare, { size: 14, className: "inline mr-1" });
  }
};

export const formatDate = (iso: string): string => {
  const d = new Date(iso);
  return (
    d.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }) +
    " " +
    d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })
  );
};

// Build the visible page-number window (max 5, ±2 around current).
export const buildPageNumbers = (page: number, totalPages: number): number[] => {
  const delta = 2;
  const range: number[] = [];
  for (let i = Math.max(1, page - delta); i <= Math.min(totalPages, page + delta); i++) {
    range.push(i);
  }
  return range;
};